import axios, { AxiosResponse } from "axios";

const apiBaseUrl = import.meta.env.VITE_CITYCOLLAB_API_BASE_URL;

const instance = axios.create({ baseURL: apiBaseUrl });
declare module "axios" {
  export interface AxiosResponse<T = any> extends Promise<T> {}
}
export interface ResponseHelper<T> {
  isSuccess: boolean;
  data: T;
}

function responseHelper(response: AxiosResponse): AxiosResponse {
  if (response?.status === 200 || response?.status === 201) {
    return response.data;
  }
  return null;
}

function errorHelper(error: any): any {
  if (error?.response?.data) {
    const message = error.response.data;

    if (message?.code) {
      const errorMessages = message.message;
      if (Array.isArray(errorMessages)) {
        errorMessages.forEach(errorMessage => {
          console.error(errorMessage);
        });
      } else {
        console.error(errorMessages);
      }
    } else {
      const errorMessages = message.message;
      if (Array.isArray(errorMessages)) {
        errorMessages.forEach(errorMessage => {
          console.error(errorMessage);
        });
      }
    }
  }
  return null;
}

instance.interceptors.request.use(
  function configHeader(config: any) {
    const authToken = localStorage.getItem("zulipToken");
    if (authToken !== undefined) {
      config.headers = {
        ...config.headers,
        Authorization: authToken,
      };
    } else {
      config.headers = { ...config.headers };
    }

    return config;
  },
  function configError(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(responseHelper, errorHelper);

export default instance;
